import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RecipeService } from './recipe.service';
import { Preferences } from '@capacitor/preferences';
import { GetRecipeResponseDTO } from './recipe.dto';
import { Share } from '@capacitor/share';
import { environment } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';
import { AuthPopupComponent } from '../shared/auth-popup/auth-popup.component';
import { AuthService } from '../auth/auth.service';
import { Clipboard } from '@capacitor/clipboard';
import { ToastController } from '@ionic/angular';
@Component({
  selector: 'app-recipe',
  templateUrl: './recipe.page.html',
  styleUrls: ['./recipe.page.scss'],
})
export class RecipePage implements OnInit, OnDestroy {
  isLoading = true;
  userId: number;
  recipeSub: Subscription;
  favSub: Subscription;
  loadedRecipe: GetRecipeResponseDTO;
  isLiked = false;
  isFeatured = false;
  url: string;
  isAccordionOpen = false;
  newDirections: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private recipeService: RecipeService,
    private modalCtrl: ModalController,
    private authService: AuthService,
    private toastController: ToastController
  ) { }

  async ngOnInit() {
    const recipeId = +this.activatedRoute.snapshot.params.id;
    this.userId = await this.authService.getUserId();
    if (recipeId > 0) {
      this.recipeSub = this.recipeService
        .getRecipeById(recipeId, this.userId)
        .subscribe((res) => {
          this.loadedRecipe = res;
          this.isLoading = false;
          this.isLiked = this.loadedRecipe.isLiked;
          this.isFeatured = false;
          this.url = environment.appUrl + '/recipe/' + this.loadedRecipe.id;

          const lines = this.loadedRecipe.howTo.split('\n');

          const formatted = lines.map(line => {
            const match = line.match(/^(\d+)-\s*(.*)/);
            if (match) {
              const stepNumber = match[1];
              const stepBody = match[2];

              const [title, ...rest] = stepBody.split("–");
              const stepTitle = title.trim();
              const description = rest.join("–").trim(); // preserve inner dashes

              if (description) {
                return `<div class="instruction-line"><strong>Step ${stepNumber}:</strong> ${stepTitle} – ${description}</div>`;
              } else {
                return `<div class="instruction-line"><strong>Step ${stepNumber}:</strong> ${stepTitle}</div>`;
              }
            } else {
              return `<div class="instruction-line">${line}</div>`;
            }
          });

          this.newDirections = formatted.join('\n');


        });
    } else {
      this.recipeSub = this.recipeService
        .getFeaturedRecipe(this.userId)
        .subscribe((res) => {
          this.loadedRecipe = res;
          this.isLoading = false;
          this.isLiked = this.loadedRecipe.isLiked;
          this.isFeatured = true;
          this.url = environment.appUrl + '/recipe/' + this.loadedRecipe.id;
          // Step 1: Split by line

          const lines = this.loadedRecipe.howTo.split('\n');

          const formatted = lines.map(line => {
            const match = line.match(/^(\d+)-\s*(.*)/);
            if (match) {
              const stepNumber = match[1];
              const stepBody = match[2];

              const [title, ...rest] = stepBody.split("–");
              const stepTitle = title.trim();
              const description = rest.join("–").trim(); // preserve inner dashes

              if (description) {
                return `<div class="instruction-line"><strong>Step ${stepNumber}:</strong> ${stepTitle} – ${description}</div>`;
              } else {
                return `<div class="instruction-line"><strong>Step ${stepNumber}:</strong> ${stepTitle}</div>`;
              }
            } else {
              return `<div class="instruction-line">${line}</div>`;
            }
          });

          this.newDirections = formatted.join('\n');

        });
    }
  }

  openSignInPopup() {
    this.modalCtrl
      .create({
        component: AuthPopupComponent,
        showBackdrop: true,
        cssClass: 'small-modal',
      })
      .then((modalEl) => {
        modalEl.onDidDismiss().then((modalData) => {
          if (!modalData.data) {
            return;
          }
          this.userId = modalData.data['userId'];
        });
        modalEl.present();
      });
  }

  async shareRecipe() {
    await Share.share({
      title: 'Check this out',
      text: `Doggos will love this recipe!! ${this.url}`, // Combine text and URL
    });
  }

  async copyLink() {
    try {
      await Clipboard.write({
        string: this.url,
      });

      const toast = await this.toastController.create({
        message: 'URL copied to clipboard!',
        color: 'primary',
        duration: 2000,
        position: 'bottom',
      });
      toast.present();
    } catch (error) {
      console.error('Failed to copy URL:', error);
      const toast = await this.toastController.create({
        message: 'Failed to copy URL.',
        duration: 2000,
        position: 'bottom',
      });
      toast.present();
    }
  }

  AddToFav() {
    if (this.userId > 0) {
      this.favSub = this.recipeService
        .AddToFavorites(this.loadedRecipe.id, this.userId)
        .subscribe((r) => (this.isLiked = true));
    } else {
      this.openSignInPopup();
    }
  }

  RemoveFromFav() {
    if (this.userId > 0) {
      this.favSub = this.recipeService
        .RemoveFromFavorites(this.loadedRecipe.id, this.userId)
        .subscribe((r) => (this.isLiked = false));
    } else {
      this.openSignInPopup();
    }
  }

  ngOnDestroy() {
    if (this.recipeSub) this.recipeSub.unsubscribe();
    if (this.favSub) this.favSub.unsubscribe();
  }
  toggleAccordion(event, detail?: CustomEvent) {
    this.isAccordionOpen = event.detail.value === 'first';
  }

}
